<app-pager [items]="attachments()" [breakpoints]="breakpoints" itemLabel="attachments">
  <h2 pagerTitle class="attachments-heading">Attachments</h2>

  <ng-template appPagerItem let-attachment>
    <button type="button" class="attachment-card" [attr.aria-label]="'Preview ' + attachment.name" (click)="preview(attachment)">
      <span class="attachment-card-header">
        <rkt-icon name="document" aria-hidden="true" />
        <span class="attachment-card-name">{{ attachment.name }}</span>
      </span>
      <span class="attachment-card-preview">
        @if (attachment.thumbnailUrl) {
          <img class="attachment-card-thumbnail" [src]="attachment.thumbnailUrl" alt="" />
        }
      </span>
    </button>
  </ng-template>
</app-pager>
